export const nomineeID = [
  "Aadhaar Card",
  "Pan Card",
  "Passport",
  "Driving Licence",
];
